//总的入口导出文件
//添加对js运行环境的判断，如果是node环境，不进行加载，避免报错
if(typeof window !== "undefined"){
	require( "./modules/io-tracker/index");
	require("./modules/log-report/index"); 
}
